<table class="table table-sm" *ngIf="taskData$ | async as task">
  <thead class="thead-dark">
    <th>Group</th>
    <th>Sub Task</th>
    <th>Status</th>
    <th>Started</th>
    <th>Finished</th>
    <th>Duration</th>
    <th>PID</th>
    <th>Comment</th>
    <th>Error</th>
    <th>Warning</th>
  </thead>
  <tbody>
    <tr *ngFor="let t of task.status"
        [ngClass]="{'text-success' : t.status === 'PASS',
                    'text-info' : t.status === 'STARTED',
                    'text-warning' : t.status === 'PENDING',
                    'text-danger' : t.status === 'FAIL'}">
      <td>{{t.group}}</td>
      <td>{{t.subtask}}</td>
      <td>{{t.status}}</td>
      <td>{{t.started}}</td>
      <td>{{t.finished}}</td>
      <td>{{t.duration}}</td>
      <td>{{t.pid}}</td>
      <td>{{t.comment}}</td>
      <td>{{t.error}}</td>
      <td>{{t.warning}}</td>
    </tr>
  </tbody>
</table>
